import React from 'react';
import Link from '../Atoms/Link';

const SumarBeneficios = () => {
    return (
        <>
            Para sumar los beneficios de <strong>Club LA NACION</strong> a tu Acceso Digital llamá al <strong>(011) 5199-4787</strong> de lunes a
            viernes de 8:00 a 20:00 hs y sábados de 8:00 a 14:00 hs. O si sos del exterior envianos un email a{' '}
            <Link href="mailto:accesodigital@lanacion.com.ar">
                <strong>accesodigital@lanacion.com.ar</strong>
            </Link>
        </>
    );
};

export default SumarBeneficios;
